import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateCustomerSettings($customerId: ID!, $blacklistWords: [String!]) {
    updateCustomerSettings(customerId: $customerId, blacklistWords: $blacklistWords) {
      blacklistWords
    }
  }
`;

export const updateBlacklistWords = (customerId, blacklistWords) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, blacklistWords },
  }).then(({ data }) => {
    const result = getSingleProp(data);
    return result?.blacklistWords || [];
  });
